import TableTabs from './TableTabs'
// Uncomment the below to migrate to stateful component
// import TableTabsContainer from './TableTabsContainer'

export { TableTabs }
export default TableTabs
// Uncomment the below to migrate to stateful component
// export { TableTabsContainer }
// export default { TableTabsContainer }
